import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import {faCloudUploadAlt, faFile} from '@fortawesome/free-solid-svg-icons';
import {StorageKeys} from 'src/app/share/enums/storage.enum';
import {ShipmentServiceService} from 'src/app/share/services/shipment/shipment-service.service';
import {StorageService} from 'src/app/share/services/storage-service/storage.service';
import {CommonService} from '../../share/services/common/common.service';

@Component({
    selector: 'app-material-upload',
    templateUrl: './material-upload.component.html',
    styleUrl: './material-upload.component.scss',
    standalone: false
})
export class MaterialUploadComponent implements OnInit {

  public faCloudUploadAlt = faCloudUploadAlt;
  public faFile = faFile;
  selectedFolder: any = '';
  uploadingFile: boolean = false;
  isUploadDocuments: boolean = true;
  isLoader : boolean = false;
  selectedFileName: string = '';
  @Input() materialData: any;
  @Output() closeOverlay = new EventEmitter<void>();
  @Output() successMessage = new EventEmitter<string>();
  selectedFile: File | null = null;
  subFolders: any;
  companyId: any;
  errorMessage: any;
  companyPrefs : any;
  scannerLicence : any;
  scanDisabled: boolean = true;
  shipmentMode:any;
  shipmentType:any;
  isScanDocument = false;
  isToast = false;

  constructor(
    readonly shipmentService: ShipmentServiceService,
    readonly storageService: StorageService,
    readonly commonService: CommonService,
  ) {
    this.companyPrefs = this.storageService.getDataFromLocalStorage(StorageKeys.PREFERENCES);
    this.scannerLicence = this.storageService.getDataFromLocalStorage(StorageKeys.SCANER_LICENCE);
    this.scanDisabled = !(this.companyPrefs?.['documentVault']?.scanner && this.scannerLicence);
  }

  ngOnInit() {
    this.getSubfoldersList();
    const selfDetailsData = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    if (selfDetailsData) {
      this.companyId = selfDetailsData.company;
    }
    this.commonService.getScanFiles()?.subscribe(file => {
      this.uploadingFile = file;
      if (file) {
        let data: any = { target: { files: [] } };
        data.target.files.push(file.blob[0])
        this.onFileSelected(data);
      }
    })
  }

  getFileExtension(fileName: string) {
    if (!fileName) {
      return '';
    }
    let extension = fileName.split('.');
    return `.${extension[extension.length - 1]}`;
  }

  upload(event: any) {
    let file = event.target.files[0];
    if (file) {
      let maxSize: number = 52428799;
      if (file.size > maxSize) {
        this.errorMessage = `File size has exceeded 50MB!`;
        this.isToast = true;
        return;
      }
    }
    event.target.value = null;
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (!file) return;
    this.selectedFile = file;
    this.selectedFileName = file.name;
    this.uploadingFile = true;
  }

  uploadFile(): void {
    this.isLoader = true ;
    if (!this.selectedFile || !this.selectedFolder) return;
    const id = this.materialData._id || this.materialData;
    let type = '';
    if (this.materialData?.selectedRegister?.key === 'Outward') {
      type = 'outbound';
    } else if (this.materialData?.selectedRegister?.key === 'Scrap') {
      type = 'scrap';
    }
    this.shipmentService.uploadFile(this.selectedFile, id, this.companyId, this.selectedFolder,type).subscribe({
      next: (res: any) => {
        this.isLoader = false;
        this.successMessage.emit('File uploaded successfully');
        this.close();
      },
      error: (error: any) => {
        this.isLoader = false;
        this.errorMessage = error?.error?.error?.message;
      }
    });
  }

  deleteFile() {
    this.selectedFile = null;
    this.selectedFileName = '';
    this.uploadingFile = false;
  }

  close() {
      this.closeOverlay.emit();
  }

  save() {
    this.isUploadDocuments = true ;
    if (this.selectedFile) {
    this.uploadFile();
    }
  }

  getSubfoldersList() {
    let id = this.materialData?._id || this.materialData;
    let type = '';
    if (this.materialData?.selectedRegister?.key === 'Outward') {
      type = 'outbound';
    } else if (this.materialData?.selectedRegister?.key === 'Scrap') {
      type = 'scrap';
    }
    let params = { type };
    this.shipmentService.getShipmentSubFolders(id, params).subscribe({
      next: (res: any) => {
        this.subFolders = res?.data?.folders;
        this.shipmentMode = res?.data?.shipmentMode;
        this.shipmentType = res?.data?.shipmentType;
        if (this.subFolders?.length) {
          this.selectedFolder = this.subFolders[0]._id;
        }
      },
      error: (error: any) => {
        console.error("Error fetching subfolders:", error);
      }
    });
  }

  isSaveDisabled(): boolean {
    return !this.selectedFile || !this.selectedFolder;
  }

  scanDocument(): void {
    this.isScanDocument = true;
  }

  closeScanDoc(file: any) {
    this.isScanDocument = false;
  }

  toTitleCase(value: string): string {
    if (!value) return '';
    return value
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

   @HostListener('window:keydown', ['$event'])
    handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape' && this.isUploadDocuments) {
        this.close();
      }
    }
}
